import { types as t } from 'mobx-state-tree';

import { defaultEditorValue } from '../SlateObj/slate-editor.store';
import { BlankItem } from './Blank/blank-item.store';

export const AbstractQuestionWithBlanks = t
  .model({
    id: t.identifier,
    editorValue: t.optional<any>(t.string, defaultEditorValue),
    blanks: t.array(BlankItem),
    title: t.maybeNull<any>(t.string),
    doubleBranchIndex: t.maybeNull(t.number)
  })
  .views((self) => ({
    get editorValueJS() {
      return JSON.parse(self.editorValue);
    },
  }));
